<template>
  <section class="entry-multi-tab">
    <main class="entry-multi-tab__wrapper">
      <a-tabs
        hideAdd
        type="editable-card"
        :activeKey="activeKey"
        @change="onChange"
        @edit="onEdit"
      >
        <a-tab-pane
          v-for="(pane,index) in panes"
          :key="pane.key"
          :closable="pane.closable"
        >
          <a-icon v-if="index === 0" slot="tab" type="home" />
          <span v-else slot="tab">{{ pane | menuNameRender }}</span>
        </a-tab-pane>

        <div slot="tabBarExtraContent">
          <div class="entry-oguide"  v-demo="'guideTo'">
            <icon-font type="gb-icon-helper-circle" style="margin-right: 5px"/>
            <span>{{ $t('layouts.operation.guide') }}</span>
          </div>
          <a-dropdown  :trigger="['click']" >
            <div class="dropdown-content">
              <a-icon type="down" />
            </div>
            <a-menu slot="overlay" @click="closeMenuClick">
              <a-menu-item key="ClosePane">{{ $t('tabs.close.current') }}</a-menu-item>
              <a-menu-item key="CloseRightPanes">{{ $t('tabs.close.right') }}</a-menu-item>
              <a-menu-item key="CloseLeftPanes">{{ $t('tabs.close.left') }}</a-menu-item>
              <a-menu-item key="CloseAllPane">{{ $t('tabs.close.all') }}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-tabs>
    </main>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EntryMultiTab',
  props: {
    panes: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  methods: {
    ...mapActions({
      remove: 'entry/ClosePane'
    }),
    onChange (activeKey) {
      this.$emit('change', activeKey)
    },
    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    closeMenuClick ({ key }) {
      const { activeKey } = this
      // 后期需要优化，尽量减少$store直接操作
      this.$store.dispatch(`entry/${key}`, activeKey)
    },
    guideTo () {
      const { activeKey } = this
      window.open('/#/middleware?toHelp=true&id=' + activeKey.replace(/[^0-9]+/, ''))
    }
  }
}
</script>

<style lang="less" scoped>
.entry-multi-tab {
  background: #fff;
  z-index: 55;
  .entry-oguide {
    display: inline-block;
    // border-left: 1px solid #eee;
    padding: 0 8px;
    color: #252B3A;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      color: #5681F4
    }
  }

  .dropdown-content {
    display: inline-block;
    padding: 0 7px;
    border-left: 1px solid #eee;
    font-size: 14px;
  }

  /deep/ .ant-tabs-bar {
    margin-bottom: 0!important;
  }

  /deep/ .ant-tabs.ant-tabs-card {
    font-size: 12px;

    .ant-tabs-extra-content {
      line-height: 36px;
    }

    .ant-tabs-card-bar {
      .ant-tabs-nav-container {
        height: 36px;
        font-size: 12px;
      }

      .ant-tabs-tab {
        margin: 0 -1px 0 0;
        border-radius: 0;
        height: 36px;
        line-height: 34px;

        &:hover {
          color: #40a9ff;
        }

        .anticon {
          margin: 0;
        }
      }
      .ant-tabs-tab-active {
        color: #1890ff;
        border-bottom: 2px solid #5681F4;
      }
    }
  }
}
</style>
